"use client";

import React from 'react';
import StatsCard1 from './StatsCard1';
import StatsCard2 from './StatsCard2';
import StatsCard4 from './StatsCard4';
import StatsCard5 from './StatsCard5';
import { useQuery } from '@tanstack/react-query';
import { fetchMentors } from '@/services/external';
import { Mentor } from '@/services/types';
const StatsSectionWorkshop = ({
  brandLogos,
  isMobile
}: {
  brandLogos: {
    image: Image;
  }[];
  isMobile: boolean;
}) => {
  const statsData = [{
    title: "This is a certified workshop",
    subtitle: "Become a certified expert",
    icon: ""
  }, {
    title: "400k+ learners",
    subtitle: "have benefitted",
    icon: `/images/course-diff/people-circle${isMobile ? 'm' : ''}.svg`,
    iconStyle: {
      alignSelf: "flex-end",
      marginBottom: "-40px",
      marginRight: "-20px",
      width: "50%",
      height: "auto"
    }
  }, {
    title: "Learn only from top mentors",
    subtitle: "here to help you through every step",
    icon: ""
  }, {
    title: "Learn insider hacks",
    subtitle: "help boost your productivity",
    icon: `/images/course-diff/list2${isMobile ? 'm' : ''}.svg`,
    iconStyle: {
      alignSelf: "center",
      marginRight: "-20px",
      marginTop: "-40px",
      marginBottom: "-40px",
      width: "50%",
      height: "auto"
    }
  }];
  const gridDataDesktop = [{
    gridRow: "1 / span 2",
    gridColumn: "1"
  }, {
    gridRow: "1",
    gridColumn: "2"
  }, {
    gridRow: "1 / span 2",
    gridColumn: "3"
  }, {
    gridRow: "2",
    gridColumn: "2"
  }];
  const gridDataMobile = [{
    gridRow: "1 / span 2",
    gridColumn: "1"
  }, {
    gridRow: "3",
    gridColumn: "1"
  }, {
    gridRow: "4 / span 2",
    gridColumn: "1"
  }, {
    gridRow: "6",
    gridColumn: "1"
  }];
  const gridData = isMobile ? gridDataMobile : gridDataDesktop;
  const spanData = [{
    cell: 0,
    cardVariant: 4
  }, {
    cell: 2,
    cardVariant: 5
  }];
  const {
    data: instructorsData
  } = useQuery<Mentor[]>({
    queryKey: ["mentors"],
    queryFn: () => fetchMentors()
  });
  return <div className="section__container--small" data-sentry-component="StatsSectionWorkshop" data-sentry-source-file="StatsSectionWorkshop.tsx">
      <div className="stats-section">
        {statsData.map((stat, index) => {
        for (let i = 0; i < spanData.length; i++) {
          if (spanData[i].cell === index) {
            switch (spanData[i].cardVariant) {
              case 2:
                return <StatsCard2 key={index} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} gridStyle={gridData[index]} logos={brandLogos} />;
              case 4:
                return <StatsCard4 key={index} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} gridStyle={gridData[index]} logos={brandLogos} />;
              case 5:
                return <StatsCard5 key={index} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} gridStyle={gridData[index]} instructorsData={instructorsData ?? []} />;
              default:
                return <StatsCard1 key={index} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} gridStyle={gridData[index]} />;
            }
          }
        }
        return <StatsCard1 key={index} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} iconStyle={stat.iconStyle} gridStyle={gridData[index]} />;
      })}
      </div>
    </div>;
};
export default StatsSectionWorkshop;